import { render, staticRenderFns } from "./proElevator.vue?vue&type=template&id=3904f200&scoped=true&"
import script from "./proElevator.vue?vue&type=script&lang=js&"
export * from "./proElevator.vue?vue&type=script&lang=js&"
import style0 from "./proElevator.vue?vue&type=style&index=0&id=3904f200&scoped=true&lang=css&"
import style1 from "./proElevator.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3904f200",
  null
  
)

export default component.exports